import EmbedHtml from '@/components/embeds/EmbedHtml/EmbedHtml'
import styles from './HTML.module.scss'

export default function HTML({
  item,
}: {
  readonly item: {
    readonly model: {
      readonly script?: string
    }
  }
}) {
  const model = item.model

  return (
    <>
      {model.script && model.script !== '' && (
        <div className={styles.wrapper}>
          <EmbedHtml html={model.script}></EmbedHtml>
        </div>
      )}
    </>
  )
}
